<template>
  <div class="results">
    <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem :to="{ name: 'RulesDecide' }"
          >原产地判定
        </BreadcrumbItem>
        <BreadcrumbItem><b>原产地判定详情</b> </BreadcrumbItem>
      </Breadcrumb>
    </div>

    <div class="results-wrap">
      <div class="results-content">

        <Content  ref="content" class="r-main" :dataSet="dataSet" :whollyObtained="whollyObtained"></Content>
      </div>
    </div>
  </div>
</template>

<script>

import Content from "./zh-CN/VoteResult";

export default {
  name: "RulesDecideVoteResult",
  components: {  Content },
  props: ['id','whollyObtained'],
  data () {
    return {
      isShowLoader: false,
      dataSet: {},
    }
  },
  watch: {
    id (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.requestData()
      }
    },
   
  },
  created () {
  
    this.requestData()
  },
  mounted () {
  
  },
  methods: {
    requestData (_id = null) {
      if (this.isShowLoader) return
      this.$Loading.start()
      this._h.scrollTop()
      this.isShowLoader = true
      this.$api.coo.determination.detail(_id || this.id, {
        success: response => {
          this.$Loading.finish()
     
          if (response.data.code === 200) {
            this.dataSet = response.data.data
           
        
            var i=this.dataSet.ftas.findIndex((value)=>value.ftaName=='RCEP');
            if(i>=0){
              let RCEPnumitem = this.dataSet.ftas[i]
              if(this.$route.query.type==1  ){
              this.dataSet.ftas =  this.dataSet.ftas.filter(item => item.ftaName!='RCEP');
              this.dataSet.ftas = [{...RCEPnumitem},...this.dataSet.ftas]
           
            }
            if(this.$route.query.type==2  ){
              this.dataSet.ftas =  this.dataSet.ftas.filter(item => item.ftaName!='RCEP');
           
              this.dataSet.ftas = [...this.dataSet.ftas,{...RCEPnumitem}]
            
            }

            }
       
            for (let index = 0; index < this.dataSet.ftas.length; index++) {
              
         
             
              this.dataSet.ftas[index].whollyObtained = this.whollyObtained
           
            }
          
        
          
            
          
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.isShowLoader = false
        },
        error: (errorMsg) => {
          this.isShowLoader = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    
  }
}
</script>
<style scoped>
  .results{
    position: relative;
    padding: 5px 0 30px;
    background-color: #fff;
  }
  .results-wrap{
    width:1400px;
    margin: 0 auto;
  }
  .shadow-divide{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    z-index: 1;
    height: 5px;
    background-color: #fff;
  }
  .ivu-breadcrumb{
    margin: 12px 0 20px;
    /*font-size: 11px;*/
 
  }
  .ivu-breadcrumb .ivu-breadcrumb-item-link,
  .ivu-breadcrumb >>> a{
    color: #999;
  }
  .ivu-breadcrumb >>> a:hover{
    color: #1F8AFD;
    text-decoration: none;
    box-shadow: none;
  }
  .ivu-breadcrumb >>> a:after{
    width: 0;
    height: 0;
  }
  .ivu-breadcrumb > span:last-child{
    color: #1F8AFD;
    font-weight: normal;
  }
  .ivu-breadcrumb >>> .ivu-breadcrumb-item-separator{
    margin: 0 2px;
  }
  .results-content{
    position: relative;
  }
  .r-main{}
</style>




// WEBPACK FOOTER //
// src/components/RulesDecide/Result.vue